import { createAsyncThunk } from '@reduxjs/toolkit';
import scheduleService from '../../services/api/scheduleService';

export const fetchSchedules = createAsyncThunk(
  'schedules/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await scheduleService.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchScheduleById = createAsyncThunk(
  'schedules/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await scheduleService.getById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createSchedule = createAsyncThunk(
  'schedules/create',
  async (schedule, { rejectWithValue }) => {
    try {
      const response = await scheduleService.create(schedule);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateSchedule = createAsyncThunk(
  'schedules/update',
  async ({ id, schedule }, { rejectWithValue }) => {
    try {
      const response = await scheduleService.update(id, schedule);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteSchedule = createAsyncThunk(
  'schedules/delete',
  async (id, { rejectWithValue }) => {
    try {
      await scheduleService.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const activateSchedule = createAsyncThunk(
  'schedules/activate',
  async (id, { rejectWithValue }) => {
    try {
      const response = await scheduleService.activate(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deactivateSchedule = createAsyncThunk(
  'schedules/deactivate',
  async (id, { rejectWithValue }) => {
    try {
      const response = await scheduleService.deactivate(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
